import { pxToRem } from './biomeTokens';

export const radiiTheme = {
  3: pxToRem(3),
  6: pxToRem(6),
  18: pxToRem(18),
  50: pxToRem(50)
};
